"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
// import { materialColors } from '../../themes/main/colors'
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var muted = _a.muted;
            return ({
                // TODO: what is this color?
                paddingBottom: theme.spacing(1),
                color: muted ? 'rgb(139, 145, 150)' : themes_1.materialColors.blue[600],
                textTransform: 'uppercase',
            });
        },
    });
});
